import clsx from 'clsx';
import { OutlineButton, PrimaryButton } from 'Components/Buttons';
import { Box, Heading, Text } from 'grommet';
import { useState } from 'preact/hooks';

import Accordion from '../../../account/Accordion';
import style from './style.scss';

const HabitatInfoCardMobile = ({
  online,
  liveTalk,
  image,
  zooName,
  zooLogo,
  title,
  description,
  onClick,
  buttonText,
  trailer,
  onShowTrailer,
  free = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onPressTrailer = () => {
    onShowTrailer(trailer);
  };

  return (
    <Accordion
      expanded={isOpen}
      className={style.accordion}
      header={
        <Box direction="row" align="center" onClick={() => setIsOpen(!isOpen)}>
          <div className={clsx(style.habitatImage, { [style.freemium]: free, [style.offline]: !online })}>
            <img src={image} alt="profile" height={42} width={42} />
            {(free || liveTalk) && (
              <div className={style.tag}>
                <div
                  className={clsx(style.habitat, {
                    [style.online]: online,
                    [style.offline]: !online,
                    [style.free]: free,
                  })}
                >
                  {liveTalk ? 'LIVE EVENT' : 'FREE'}
                </div>
              </div>
            )}
          </div>
          <Heading level={4} margin={{ left: '15px' }}>
            {title}
          </Heading>
          <img src={zooLogo} alt={zooName} className={style.zooLogo} height={26} width={52} />
        </Box>
      }
    >
      <Box height={{ min: '132px' }} style={{ borderBottom: '1px solid #EBEBEB' }}>
        <Box pad={{ vertical: '25px' }}>
          <Text size="xlarge">{description}</Text>
        </Box>
        <Box direction="row" justify="between" align="center" margin={{ bottom: '25px' }}>
          <div onClick={onClick}>
            <PrimaryButton label={buttonText} style={{ minWidth: '126px' }} />
          </div>
          {trailer && (
            <OutlineButton
              label="Trailer"
              height="45px"
              style={{ minWidth: '126px', width: '126px' }}
              width="126px"
              onClick={onPressTrailer}
            />
          )}
        </Box>
      </Box>
    </Accordion>
  );
};

export default HabitatInfoCardMobile;
